"use strict";

exports.__esModule = true;
var _exportNames = {
  isNumericType: true
};
exports.isNumericType = void 0;
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  exports[key] = _types[key];
});
var _componentDefaults = require("./component-defaults");
Object.keys(_componentDefaults).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _componentDefaults[key]) return;
  exports[key] = _componentDefaults[key];
});
var _manifestMappers = require("./manifest-mappers");
exports.isNumericType = _manifestMappers.isNumericType;
//# sourceMappingURL=index.js.map